<template>
  <Card class="modalCard">
    <div class="block">
      <h4 class="modalTitle title is-4"><slot name="title" /></h4>
    </div>

    <hr />
    
    <div class="block">
      <slot />
    </div>

    <hr />
    
    <div class="block level">
      <div class="level-item level-right buttonGroup">
        <button v-if="!hideClose" class="button" @click="closeModal">Close</button>
        <slot name="buttons" />
      </div>
    </div>
  </Card>
</template>

<script>
import { defineComponent } from 'vue'

import Card from '@/components/Card'

import useModal from '@/hooks/useModal'

export default defineComponent({
  props: {
    hideClose: {
      type: Boolean
    }
  },

  components: {
    Card
  },

  setup () {
    const { closeModal } = useModal()

    return {
      closeModal
    }
  }
})
</script>

<style lang="sass">
.modalCard
  margin: 1rem

  .modalTitle
    font-family: 'Playfair Display', sans-serif

  .buttonGroup
    > *
      margin-left: 0.5rem
</style>
